const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/work-item-usage/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermission } from '@/common/hooks/usePermissions';
export const Route = createFileRoute('/(app)/org/$org/settings/work-item-usage')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ctx => {
    await requirePermission('view_billing')(ctx);
    if (!ctx.context.flags.workItemUsageEnabled) {
      throw redirect({
        to: '/org/$org',
        params: {
          org: ctx.params.org
        },
        replace: true
      });
    }
  }
});